module.exports = __webpack_public_path__ + "img/Slice2@2x.1cdb7b9c.png";